window.addEventListener("load", function () {
  const container = document.getElementById("msrt-container");
  const reopenBtn = document.getElementById("reopen-pd-btn");
  if (!container) return;

  function startWidget() {
    if (typeof Msrt === "undefined") {
      console.log("Msrt undefined, retrying...");
      setTimeout(startWidget, 500);
      return;
    }

    try {
      if (reopenBtn) reopenBtn.style.display = "none";
      if (container) container.style.display = "block";

      // Clear any previous iframe to avoid duplicates
      container.innerHTML = "";

      Msrt.createWidget("msrt-container", {
        apiKey: "eOJI2pU5eJlWUnYXWvu9I74MfWX-aLfkznaSNY2l5s-DrR7f0uNhPw",
        onGetResultPd: (result) => {
          console.log("Results:", result);
        },
        onClose: () => {
          console.log("PD Tool Closed");
          if (container) container.style.display = "none";
          if (reopenBtn) reopenBtn.style.display = "block";
        },
        pdCopyClipboard: true,
      });
      console.log("Msrt initialized successfully.");
    } catch (error) {
      console.error("Msrt initialization error:", error);
    }
  }

  if (reopenBtn) {
    reopenBtn.addEventListener("click", function () {
      startWidget();
    });
  }

  // Initial load
  startWidget();
});
